import { Component, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import {
  MatPaginator,
  MatPaginatorIntl,
  PageEvent
} from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { NotificationService } from 'src/app/_services/notification.service';
import { ProfileService } from 'src/app/_services/profile.service';
import { TimesheetService } from 'src/app/_services/timesheet.service';
import Swal from 'sweetalert2';
import { BaseComponent } from '../base/base.component';

@Component({
  selector: 'app-card-notifiche',
  templateUrl: './card-notifiche.component.html',
  styleUrls: ['./card-notifiche.component.css']
})
export class CardNotificheComponent extends BaseComponent {
  notification: any;
  read: any;
  id: any;
  profile: any;
  profileData: any;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  obs: BehaviorSubject<any>;
  pageEvent: PageEvent;
  totalItems: number;
  currentPage: number = 1;
  pageSize: number = 5;
  skip = 0;
  take: any;
  dataSource: MatTableDataSource<any>;
  categories: any;
  currentType: any;
  currentCategory: any;
  CountUnRead: number = 0;

  categoryControl = new FormControl<string>('');

  id_notifica: any;
  defaultSystemImg: any;
  defaultHobbyImg: any;
  userRole: any;
  toggleCheck: boolean = false;
  onlyCheck: boolean = false;
  arrayCheck: string[] = [];
  isMobile: boolean = false;
  isTablet: boolean = false;
  isDesktop: boolean = false;
  limit: number = 0;

  types: any[] = ['Tutti', 'Già letti', 'Da leggere'];

  toggleCategory: any = '';

  constructor(
    private readonly notificationService: NotificationService,
    private readonly profileService: ProfileService,
    private readonly route: ActivatedRoute,
    private readonly paginatorIntl: MatPaginatorIntl,
    private readonly timesheetService: TimesheetService,
    private readonly title: Title
  ) {
    super();
    this.defaultSystemImg = this.utilityService.getSanitizeUrl(
      'image/projects/default.png'
    );
    this.defaultHobbyImg = this.utilityService.getSanitizeUrl(
      'image/hobbies/default.png'
    );
  }

  async ngOnInit(): Promise<void> {
    this.utilityService.setTitle('Notifiche');
    this.title.setTitle('Notifiche | Sviluppo Personale');
    /**
     * Per il responsive bisogna creare un limite di caratteri da mostrare, nell'header, per la notifica dei sondaggi
     * Ad esempio è stato impostato che quando siamo nella visualizzazione in desktop possiamo mostrare un massimo di
     * 75 caratteri, (settare la variabile limit)
     */
    const screenWidth = window.innerWidth;
    if (screenWidth <= 576) {
      this.isMobile = true;
    } else if (screenWidth >= 577 && screenWidth <= 991) {
      this.isTablet = true;
    } else {
      this.isDesktop = true;
      this.limit = 75;
    }
    this.profileData = await this.profileService.getUserRoleAsync();
    this.userRole = this.profileData.roles[0].name;
    this.dataSource = new MatTableDataSource<any>(this.notification);
    this.dataSource.paginator = this.paginator;
    this.pageEvent = new PageEvent();
    this.pageEvent.pageSize = this.take;
    this.pageEvent.pageIndex = 0;
    this.pageEvent.length = 0;
    this.paginatorIntl.itemsPerPageLabel = 'Elementi per pagina';
    this.paginatorIntl.getRangeLabel = (
      page: number,
      pageSize: number,
      length: number
    ) => {
      if (length === 0 || pageSize === 0) {
        return `0 di ${length}`;
      }
      length = Math.max(length, 0);
      const startIndex = page * pageSize;
      const endIndex =
        startIndex < length
          ? Math.min(startIndex + pageSize, length)
          : startIndex + pageSize;
      return `${startIndex + 1} - ${endIndex} di ${length}`;
    };
    this.getNotification();
    this.getAllCategoryTypes();
  }

  goToNew(data: any) {
    let path: string = '';

    if (data.category != 'Hobby') {
      path = data.name.toLowerCase();
    }

    if (data.category == 'Hobby' && this.userRole != 'admin')
      path += '/profilo-utente';
    else if (data.category == 'Hobby' && this.userRole == 'admin')
      path += '/impostazioni-admin/gestione-hobby';
    else if (
      data.category == 'Richiesta supporto' ||
      data.category == 'Commento'
    )
      path += '/supporto-ai-colleghi';
    else if (data.category == 'Consiglio utile') path += '/consigli-utili';
    else if (data.category == 'Feedback') path = '/feedback';
    else if (data.category == 'Review') path += '/requirements';
    else if (data.category == 'Documentazione') {
      path += '/documentazione';
    }

    const navigationExtras = {
      relativeTo: this.route,
      queryParams: { id: data.reference_id }
    };
    this.router.navigate(['../' + path], navigationExtras);
  }

  /* Funzione per evitare che l'expansion panel della notifica si chiuda ad ogni azione di refresh dati */
  notificationTrackBy(request: any) {
    return request.id;
  }

  getNotification(_category?: string) {
    let utility = this.utilityService;
    this.resetCheck();

    if (!this.categoryControl.value) this.categoryControl.patchValue('');

    this.notificationService
      .getNotification({
        category: this.categoryControl.value,
        skip: (this.currentPage - 1) * this.pageSize,
        take: this.pageSize
      })
      .subscribe(res => {
        this.totalItems = res.total;
        this.notification = Object.values(res.data);

        this.notification.map((value: any) => {
          value['check'] = false;
        });

        this.notification.forEach(function (notification: any) {
          if (notification.data.sender?.filestorage) {
            notification.data.sender.filestorage.path = utility.getSanitizeUrl(
              notification.data.sender?.filestorage.path
            );
          }

          if (notification.data.share) {
            notification.data.share.arguments.filestorage.path =
              utility.getSanitizeUrl(
                notification.data.share.arguments.filestorage.path
              );
          }

          if (notification.data.image) {
            notification.data.image = utility.getSanitizeUrl(
              notification.data.image
            );
          }
        });
        this.dataSource = new MatTableDataSource<any>(this.notification);
        this.obs = this.dataSource.connect();
      });
  }

  onPageChange(event: PageEvent) {
    this.currentPage = event.pageIndex + 1;
    this.pageSize = event.pageSize;
    this.getNotification();
  }

  getNotiCategory(category: string) {
    let innerHTML;

    switch (category) {
      case 'Sistema':
        innerHTML = `<span class="material-symbols-outlined">
                      manufacturing
                    </span>`;
        break;

      case 'Hobby':
        innerHTML = `<span class="material-symbols-outlined">
                      extension
                    </span>`;
        break;

      case 'Review':
        innerHTML = `<span class="material-symbols-outlined">
                        rate_review
                    </span>`;
        break;

      case 'Percorso di crescita':
        innerHTML = `<span class="material-symbols-outlined">
                        timeline
                    </span>`;
        break;

      case 'Riflessioni':
        innerHTML = `<span class="material-symbols-outlined">
                        emoji_objects
                    </span>`;
        break;

      case 'Richiesta supporto':
        innerHTML = `<span class="material-symbols-outlined">
                        contact_support
                    </span>`;
        break;

      case 'Commento':
        innerHTML = `<span class="material-symbols-outlined">
                        forum
                    </span>`;
        break;

      case 'Sistema Prof':
        innerHTML = `<span class="material-symbols-outlined">
                        school
                    </span>`;
        break;

      case 'Consiglio utile':
        innerHTML = `<span class="material-symbols-outlined">
                        tips_and_updates
                    </span>`;
        break;

      case 'Documentazione':
        innerHTML = `<span class="material-symbols-outlined">
                        import_contacts
                    </span>`;
        break;

      case 'Condivisione':
        innerHTML = `<span class="material-symbols-outlined">
                        share
                    </span>`;
        break;

      case 'Feedback':
        innerHTML = `<span class="material-symbols-outlined">
                        feedback
                    </span>`;
        break;

      case 'Like':
        innerHTML = `<span class="material-symbols-outlined">
                        favorite
                    </span>`;
        break;

      case 'Sondaggi':
        innerHTML = `<img src="assets/images/Shared/sondaggi.svg" alt="sondaggi" heigth="24px" width="24px">`;
        break;

      case 'Feedback 360':
        innerHTML = `<img src="assets/images/Shared/sondaggi360.svg" alt="feedback360" heigth="24px" width="24px">`;
        break;

      /* andare ad inserire l'src, sul tag image, relativo all'immagine di autovalutazione */
      case 'Autovalutazione':
        innerHTML = `<img src="assets/images/Shared/self-evaluation.svg" alt="self-evaluation" heigth="24px" width="24px">`;
        break;

      case 'Timesheet':
        innerHTML = `<img src="assets/images/Shared/overview.svg" alt="timesheet" heigth="24px" width="24px">`;
        break;

      case 'Sbi':
        innerHTML = `<img src="assets/images/Shared/sbi.svg" alt="SBI" heigth="24px" width="24px">`;
        break;

      case 'Calendario':
        innerHTML = `<i class="icons calendar fill-svg-blue-500"></i>`;
        break;
    }

    return `${innerHTML}`;
  }

  async goToSbi(data: any): Promise<void> {
    const navigationExtras: any = {
      fragment: data.reference_id.toString()
    };

    if (data.queryParamShouldBeSet) {
      navigationExtras.queryParams = {
        sender_id: data.sender.id
      };
    }

    if (data?.data && data.data.created_at) {
      navigationExtras.queryParams = {
        ...(navigationExtras.queryParams || {}),
        lastReviewStartDate: data.data.created_at
      };
    }

    await this.router.navigate(['/secure/dashboard/sbi'], navigationExtras);
  }

  goToCalendar(data: any) {
    const navigationExtras = {
      state: {
        sender_id: data.sender.id,
        user_uuid: data.reference_id,
        date: data.date
      }
    };

    this.router.navigate(['/secure/dashboard/calendar'], navigationExtras);
  }

  set_Read(id_notifica: any, read: boolean) {
    this.read = true;
    read = this.read;
    this.notificationService.set_Read(id_notifica, this.read).subscribe({
      next: () => {
        {
          this.getNotification();
          this.notificationService.setNotifications(read);
        }
      }
    });
  }

  getElement(element: any) {
    this.id = element;
    this.getProfileUser();
  }

  getProfileUser() {
    this.profileService.profileUser(this.id).subscribe(res => {
      this.profile = res.result;
    });
  }

  stopEventPropagation(event: Event): void {
    event.stopPropagation();
  }

  getAllCategoryTypes() {
    this.notificationService.getAllCategoryTypes().subscribe(res => {
      this.categories = res.result;
    });
  }

  chooseCategory(category: any) {
    //this.currentCategory = category
    this.getNotification(category);
  }

  clearSelect() {
    this.categoryControl.patchValue('');
    this.getNotification();
  }

  changeCheckBox(id?: any, event?: boolean) {
    if (event) {
      this.currentType = 'Tutti';
      this.notification.map((value: any) => {
        if (
          value.data['category'] != 'Condivisione' ||
          value.data['status'] != 'pending'
        ) {
          if (!this.arrayCheck.includes(value.id)) {
            this.arrayCheck.push(value.id);
            value.check = true;
            if (!value.read_at) {
              this.CountUnRead++;
            }
          }
        }
      });
    } else if (event == false) {
      this.currentType = null;

      this.notification.map((value: any) => {
        if (this.arrayCheck.includes(value.id)) {
          value.check = false;
          if (!value.read_at) {
            this.CountUnRead--;
          }
        }
      });

      this.arrayCheck = [];
    } else {
      if (!this.arrayCheck.includes(id)) {
        this.arrayCheck.push(id);

        this.notification.map((value: any) => {
          if (value.id == id) {
            value.check = true;
            if (!value.read_at) {
              this.CountUnRead++;
            }
          }
        });
      } else {
        this.notification.map((value: any) => {
          if (value.id == id) {
            value.check = false;
            if (!value.read_at) {
              this.CountUnRead--;
            }
          }
        });

        let index = this.arrayCheck.indexOf(id);
        this.arrayCheck.splice(index, 1);
      }
    }

    this.arrayCheckLength();
  }

  onSelectClick(type: any) {
    this.currentType = type;

    if (this.currentType == 'Tutti') {
      this.notification.map((value: any) => {
        if (
          value.data['category'] != 'Condivisione' ||
          value.data['status'] != 'pending'
        ) {
          if (!this.arrayCheck.includes(value.id)) {
            this.arrayCheck.push(value.id);
            value.check = true;
            if (!value.read_at) {
              this.CountUnRead++;
            }
          }
        }
      });
    } else if (this.currentType == 'Già letti') {
      this.arrayCheck = [];
      this.CountUnRead = 0;
      this.notification.map((value: any) => {
        if (
          value.data['category'] != 'Condivisione' ||
          value.data['status'] != 'pending'
        ) {
          if (value.read_at) {
            this.arrayCheck.push(value.id);
            value.check = true;
          } else {
            value.check = false;
          }
        }
      });
    } else {
      this.CountUnRead = 0;
      this.arrayCheck = [];
      this.notification.map((value: any) => {
        if (
          value.data['category'] != 'Condivisione' ||
          value.data['status'] != 'pending'
        ) {
          if (!value.read_at) {
            this.arrayCheck.push(value.id);
            value.check = true;
            this.CountUnRead++;
          } else {
            value.check = false;
          }
        }
      });
    }

    this.arrayCheckLength();
  }

  arrayCheckLength() {
    if (this.arrayCheck.length >= 1) {
      this.onlyCheck = true;
    } else {
      this.resetCheck();
    }
  }

  markAsReadAllSelected() {
    this.notificationService
      .markAsReadAllSelected(this.arrayCheck)
      .subscribe(() => {
        let messageText = this.arrayCheck[1]
          ? 'Notifiche segnate come lette'
          : 'Notifica segnata come letta';
        this.getNotification();

        Swal.fire({
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 2000,
          timerProgressBar: true,
          icon: 'success',
          iconColor: '#FFB26B',
          title: messageText,
          didOpen: toast => {
            toast.addEventListener('mouseenter', Swal.stopTimer);
            toast.addEventListener('mouseleave', Swal.resumeTimer);
          }
        });
      });
  }

  destroyAllSelected() {
    this.notificationService
      .destroyAllSelected(this.arrayCheck)
      .subscribe(() => {
        let messageText = this.arrayCheck[1]
          ? 'Notifiche eliminate'
          : 'Notifica eliminata';
        this.getNotification();

        Swal.fire({
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 2000,
          timerProgressBar: true,
          icon: 'success',
          iconColor: '#FFB26B',
          title: messageText,
          didOpen: toast => {
            toast.addEventListener('mouseenter', Swal.stopTimer);
            toast.addEventListener('mouseleave', Swal.resumeTimer);
          }
        });
      });
  }

  markAsUnreadAllSelected() {
    this.notificationService
      .markAsUnreadAllSelected(this.arrayCheck)
      .subscribe(() => {
        let messageText = this.arrayCheck[1]
          ? 'Notifiche segnate come non lette'
          : 'Notifica segnata come non letta';
        this.getNotification();

        Swal.fire({
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 2000,
          timerProgressBar: true,
          icon: 'success',
          iconColor: '#FFB26B',
          title: messageText,
          didOpen: toast => {
            toast.addEventListener('mouseenter', Swal.stopTimer);
            toast.addEventListener('mouseleave', Swal.resumeTimer);
          }
        });
      });
  }

  //modale per eliminare le notifiche
  deleteNotificationModal() {
    Swal.fire({
      text: `Sei sicuro di voler eliminare ${
        this.arrayCheck[1] ? 'le notifiche' : 'la notifica'
      } ?`,
      showCancelButton: true,
      cancelButtonText: 'Annulla',
      cancelButtonColor: '#00337C',
      showConfirmButton: true,
      confirmButtonText: 'Conferma',
      confirmButtonColor: '#FFB26B',
      reverseButtons: true,
      focusConfirm: false,
      customClass: {
        popup: 'main-font'
      },
      backdrop: '#f4f3efad',
      position: 'center'
    }).then(result => {
      if (result.isConfirmed) {
        this.destroyAllSelected();
      }
    });
  }

  resetCheck() {
    this.onlyCheck = false;
    this.CountUnRead = 0;
    this.arrayCheck = [];
  }

  truncateText(
    value: string,
    limit: number = this.limit,
    suffix: string = '...'
  ): string {
    if (!value) return '';
    return value.length > limit ? value.substring(0, limit) + suffix : value;
  }

  /**
   * questa funzione serve per far fare il redirect verso una pagina specifica controllando se l'utente che ha ricevuto la notifica
   * è un untente partecipante o un admin
   * l'utente partecipante viene rimandato al riepilogo del sondaggio
   * l'utente admin viene mandato al riepilogo sondaggio
   * @param id id del sondaggio
   * @param recievingRole ruolo dell'utente rispetto alla notifica
   * @param event evento scatenato al click
   */
  redirectToSurvey(id: number, recievingRole: number, event: Event) {
    if (recievingRole == 1)
      this.goTo('secure/dashboard/survey-detail/' + id, event);
    else if (recievingRole == 2)
      this.goTo('secure/dashboard/survey-answers/' + id, event);
  }

  redirectToTimesheet(date: string, chosenUser: any, event: Event) {
    this.timesheetService.chosenUser = chosenUser;
    this.timesheetService.date = new Date(date);
    this.goTo('secure/dashboard/timesheet', event);
  }

  formatDescription(text: string) {
    // Sostituisce ogni newline con un tag <br>
    return text.replace(/\n/g, '<br>');
  }
}
